module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "click-thru hideme"
  }, [_c('div', {
    staticClass: "clickthru-top"
  }, [_vm._v(_vm._s(_vm.clickThru.superHeader))]), _vm._v(" "), _c('div', {
    staticClass: "clickthru-middle",
    on: {
      "click": _vm.nextCategory
    }
  }, [_vm._v(_vm._s(_vm.clickThru.mainText))]), _vm._v(" "), _c('div', {
    staticClass: "clickthru-bottom"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54dd549f","transformToRequire":{"video":["src","poster"],"source":"src","object":"data","iframe":"src","embed":"src","a":"href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClickThru.vue
// module id = 229
// module chunks = 0